import { useEffect, useState } from "react";

const Footer = () => {
  const [version, setVersion] = useState("");
  console.log(version);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const configRes = await fetch(`${process.env.PUBLIC_URL}/config.json`);
        const config = await configRes.json();
        setVersion(config.version);
      } catch (error) {
        console.error("Failed to load config.json", error);
      }
    };

    fetchConfig();
  }, []);
  const quickLinkList = [
    "Điều khoản điều kiện",
    "Giới thiệu về J88",
    "Miễn trừ trách nhiệm",
    "Chính sách bảo mật",
    "Câu hỏi thường gặp",
    "Chơi có trách nhiệm",
    "Hợp tác đại lý",
  ];

  const syntheicList = [
    "Thể Thao",
    "Casino",
    "Nổ Hũ",
    "Bắn Cá",
    "Game Bài",
    "Đá Gà",
    "Xổ Số",
  ];
  return (
    <footer className="bg-red-600 text-white text-sm pt-10 pb-6 px-6 w-full flex flex-col">
      <div className="flex flex-col lg:flex-row w-full justify-center gap-x-6">
        <div className="w-full lg:w-1/4 mb-4 mr-3 flex flex-col px-6 lg:p-0">
          <img
            src={`${process.env.PUBLIC_URL}/img/footer-j88.png`}
            alt="J88 Logo"
            className="h-22 lg:h-24 w-2/3 lg:mb-4"
          />
          <p className="mt-2 text-sm lg:text-xs lg:pr-10">
            <strong>J88</strong> có các trò chơi Casino giúp người chơi khi chơi
            Casino Online. Không chỉ có hàng trăm trò chơi Casino, chúng tôi còn
            gửi tặng nhiều phần thưởng và khuyến mãi cho các thành viên của
            mình.
          </p>
        </div>
        <div className="flex lg:hidden flex-col gap-y-2 px-6">
          <img
            src={`${process.env.PUBLIC_URL}/img/footerMobile1.png`}
            className="w-full h-12 md:h-16 "
          />
          <img
            src={`${process.env.PUBLIC_URL}/img/footerMobile2.png`}
            className="w-4/5 h-16 md:h-20"
          />
        </div>
        <div className="hidden lg:flex flex-col w-full md:w-1/6 mb-4">
          <h4 className="font-bold text-white text-lg mb-2 flex items-center gap-2">
            <img
              src={`${process.env.PUBLIC_URL}/icon/setting.png`}
              className="w-4 h-4"
            />
            LIÊN KẾT NHANH
          </h4>
          <ul className="space-y-2 text-xs">
            {quickLinkList.map((text, index) => (
              <li key={index} className=" border-b last:border-b-0">
                <a
                  href="https://cpqtr.ink/"
                  target="_blank"
                  className="flex flex-row items-center gap-1 pb-2 last:border-b-0"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/icon/double-arrow-right.png`}
                    className="w-3 h-3"
                  />
                  {text}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="hidden lg:flex flex-col w-full md:w-1/6 mb-4">
          <h4 className="font-bold text-white text-lg mb-2 flex items-center gap-2">
            <img
              src={`${process.env.PUBLIC_URL}/icon/spade.png`}
              className="w-4 h-4"
            />
            TỔNG HỢP
          </h4>
          <ul className="space-y-2 text-xs">
            {syntheicList.map((text, index) => (
              <li key={index} className=" border-b last:border-b-0">
                <a
                  href="https://cpqtr.ink/"
                  target="_blank"
                  className="flex flex-row items-center gap-1 pb-2 last:border-b-0"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/icon/double-arrow-right.png`}
                    className="w-3 h-3"
                  />
                  {text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="hidden lg:flex justify-center space-x-4 mt-6">
        <img
          src={`${process.env.PUBLIC_URL}/img/footerLogo.png`}
          alt="footerLogo"
          className="h-9 2xl:h-12 mb-2"
        />
      </div>

      <div className="hidden lg:flex justify-center text-xs 2xl:text-sm mt-4">
        Copyright © J88.com là nơi lý tưởng cho người chơi tham gia giải trí,
        sản phẩm trò chơi hấp dẫn hãy nhanh tay tham gia để được trải nghiệm
        dịch vụ tốt nhất.
      </div>
    </footer>
  );
};

export default Footer;
